<template>
  <div class="duty_container">
    <div :class="{
        container_bg: true,
        container_green: curBG === 'typeGreen' ? true : false,
      }">
      <img :src="getContainerBG" v-if="backgroundMask" />
    </div>
    <div class="overal_bg" v-if="curBG == 'typeDark'"></div>
    <div class="overal_bg_strong" v-if="curBG == 'typeStrong'"></div>
    <left-part :modelType="modelType" v-if="!isSetting && refreshTag"></left-part>
    <right-part :modelType="modelType" v-if="!isSetting && refreshTag"></right-part>
    <setting style="z-index: 2" :modelType="modelType" v-if="isSetting"></setting>
    <!--button class="changeSet" @click="click"></button-->

    <!-- <centerMod v-if="bme3dManagerLoaded" /> -->
    <template v-if="dutyType === 'twoSide'">
      <duty-popup-upgrade :dutyType="'twoSide'" v-if="refreshTag && customerId != 3" ref="dutyPopupUpgrade"></duty-popup-upgrade>
      <duty-popup-upgrade3 :dutyType="'twoSide'" v-if="refreshTag && customerId == 3" ref="dutyPopupUpgrade"></duty-popup-upgrade3>
    </template>
    <template v-else-if="dutyType === 'upgrade'">
      <duty-popup-upgrade :dutyType="'upgrade'" ref="dutyPopupUpgrade" v-if="refreshTag"></duty-popup-upgrade>
    </template>
    <template v-else-if="dutyType === 'followMode'">
      <duty-popup-tiny v-if="refreshTag" ref="dutyPopupUpgrade"></duty-popup-tiny>
    </template>
    <duty-science v-if="refreshTag"></duty-science>
    <!-- <pupButton></pupButton> -->
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import leftPart from "@/modules/DIYcomponents/leftPart.vue";
import rightPart from "@/modules/DIYcomponents/rightPart.vue";
import setting from "@/modules/DIYcomponents/setting.vue";
import dutyPopup from "@/modules/dutyComponents/dutyPopup/index.vue";
import dutyPopupUpgrade from "@/modules/dutyComponents/dutyPopup/index_upgrade.vue";
import dutyPopupUpgrade3 from "@/modules/dutyComponents/dutyPopup/index_upgrade3.vue";
import dutyPopupNew from "@/modules/dutyComponents/dutyPopup/index_new.vue";
import dutyPopupTiny from "@/modules/dutyComponents/dutyPopup/index_tiny.vue";
import dutyScience from "@/modules/dutyComponents/dutyScience/index.vue";

import { mapState } from "vuex";

import { unorganizedLightWallRender } from "@/assets/js/lightWall/unorganized_science.js";
import { dutyLightWallRender } from "@/assets/js/lightWall/duty_science.js";

import { ref, shallowRef, computed, provide, getCurrentInstance } from "vue";
import { useRouter, onBeforeRouteUpdate } from "vue-router";

import { CamLeapFunc } from "@/assets/js/unity3D/index.js";
import {dateFormat} from "utils/tools";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    leftPart,
    rightPart,
    setting,
    dutyPopup,
    dutyPopupTiny,
    dutyScience,
    dutyPopupNew,
    dutyPopupUpgrade,
    dutyPopupUpgrade3
  },
  props: {},
  setup() {
    //const router = useRouter();
    const { proxy } = getCurrentInstance(); // 获取当前组件实例
    const ctx = proxy;

    onBeforeRouteUpdate((to) => {
      ctx.pageName = to.name;
    });
  },
  data() {
    //这里存放数据
    return {
      pageInfo: 'DutyMod.vue',
      computedName: '值守模式首页组件',
      backgroundMask: bmeConfig.backgroundMask,
      customerId: this.$store.state.customerId,
      bme3dManagerLoaded: false,
      isSetting: false,
      hash: false,
      modelType: "DutyMod",
      styleType: "",
      styleTypeMap: {},
      curBG: "",
      refreshTag: true,
      eventData: {},
      dutyType: "",
    };
  },
  //计算属性 类似于data概念
  // computed: {
  //   ...mapState([''])
  //   },
  computed: {
    getContainerBG: function () {
      let imgSrc = "";
      if (
        this.curBG &&
        this.styleTypeMap[this.curBG] &&
        this.styleTypeMap[this.curBG].dutyBG
      ) {
        imgSrc = require("@/views/MainMod/img/" +
          this.styleTypeMap[this.curBG].dutyBG);
      }
      if (!bmeConfig.backgroundMask) {
        imgSrc = "";
      }
      return imgSrc;
    },
    curBGVal: function () {
      return this.$store.state.curBG;
    },
    dutyModelTypeVal() {
      return this.$store.state.dutyType;
    },
  },
  provide: function () {
    return {
      getEventData: computed(() => this.eventData),
      updateEventData: this.updateEventData,
    };
  },
  //监控data中的数据变化
  watch: {
    hash: {
      handler(newVal, oldVal) {
        this.isSetting = newVal;
      },
      deep: true,
    },
    curBGVal: {
      handler(newVal, oldVal) {
        this.curBG = newVal;
      },
      deep: true,
    },
    dutyModelTypeVal: {
      handler(newVal, oldVal) {
        this.dutyType = newVal;
      },
      deep: true,
    },
    /*$route: {
      handler(newVal, oldVal) {
        console.log(newVal);
      },
      deep: true,
    },*/
  },
  errorCaptured(error,vm,info) {
    console.log('kk-',error,vm,info);
    let msg = '错误信息：' + error + '，错误详情：' + info;
    let computedName = vm.mtitle || vm.computedName;
    return false;
    // this.requestExceptCap(msg,instance);
  },
  //方法集合
  methods: {
    /**
     * @Description: 全局异常捕获上传
     * @param {String} msg 报错信息
     * @param {Object} instance 报错组件
     * @return void
     * @author liqiuyu
     * @date 2024/3/12
     */
    requestExceptCap(msg, instance) {
      const date = new Date();
      const time = dateFormat('YYYY-mm-dd HH:MM:SS',date);
      const url = this.$apiOpt.platformCollect;

      const param = {
        firstLevelCode: 'notOpen',
        secondLevelCode: 'beforeError',
        additionalInfo: {
          source: 'screen',
          mac: '867788sjgdjbsd',
          customerId: window.bmeConfig.customerSign,
          sourceFile: instance.computedName,
          sourcePage: instance.pageInfo,
          time: time,
          msg: msg
        }
      }
      this.$apiUtils.post(url,param).then(res => {

      }).catch(error => {

      });
    },
    click() {
      if (this.hash) {
        this.$router.push({ path: "/", hash: "" });
      } else {
        this.$router.push({ path: "/", hash: "#setting" });
      }
    },
    isBme3dManagerLoaded() {
      if (bmeConfig.mapType !== "3D") return;
      if (window.g_bme3dManager) {
        this.bme3dManagerLoaded = true;
      } else {
        let that = this;
        if (that.loadedTimer) {
          clearTimeout(that.loadedTimer);
        }
        that.loadedTimer = setTimeout(function () {
          that.isBme3dManagerLoaded();
        }, 500);
      }
    },
    updateEventData(item) {
      this.eventData = item;
    },
    reset() {
      this.modelType = "DutyMod";
      this.refreshTag = true;
      this.eventData = {};
    },
    reload() {
      this.refreshTag = false;
      this.$nextTick(function () {
        this.reset();
        this.refreshTag = true;
      });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    if (this.$route.query && this.$route.query.setting == "true") {
      this.hash = true;
    } else {
      this.hash = false;
    }

    if (!window.testTime) {
      window.testTime = new Date().getTime();
    }
    let delta = (new Date().getTime() - window.testTime) / 1000;
    console.log("created-duty", delta);

    this.isBme3dManagerLoaded();
  },
  beforeMount() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.curBG = this.$store.state.curBG;

    this.dutyType = bmeConfig.dutyType;
    this.styleTypeMap = window.styleTypeMap;
    this.styleType = bmeConfig.styleType;
  },
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
  deactivated() {},
  beforeUnmount() {},
  beforeRouteUpdate(to, from) {
    if (to.query && to.query.setting == "true") {
      this.hash = true;
    } else {
      this.hash = false;
    }
    this.reload();
  },
  beforeRouteEnter(to, from) {
    /*dutyLightWallRender(true, "update");
    unorganizedLightWallRender(false);*/
    CamLeapFunc();
  },
  beforeRouteLeave(to, from) {
    /*if (this.$refs.dutyPopupUpgrade) {
      this.$refs.dutyPopupUpgrade.$data &&
        this.$refs.dutyPopupUpgrade.$data.preventStopTimer &&
        clearTimeout(this.$refs.dutyPopupUpgrade.$data.preventStopTimer);
      this.$isStop.status = true;
      this.$refs.dutyPopupUpgrade.timeoutClear();
    }
    next();
    */
  },
};
</script>
<style scoped>
.duty_container {
  position: absolute;
  left: 0px;
  top: 0px;
  bottom: 0px;
  right: 0px;
}

.container_bg {
  position: absolute;
  left: 0px;
  top: 0px;
  bottom: 0px;
  right: 0px;
  z-index: -1;
}

.container_bg > img {
  filter: opacity(100%) grayscale(15%) blur(1px) contrast(95%) saturate(95%);
  width: 102%;
  height: 100%;
}

.container_green {
  filter: opacity(70%) grayscale(15%) blur(1px) contrast(95%) saturate(95%) !important;
}

.overal_bg {
  position: absolute;
  left: 15px;
  top: 120px;
  bottom: 15px;
  right: 15px;
  background-image: url("/static/images/common/overal.png");
  background-size: 100% 100%;
  background-repeat: "no-repeat";
  z-index: -1;
}
.overal_bg_strong {
  position: absolute;
  left: 15px;
  top: 120px;
  bottom: 15px;
  right: 15px;
  background-image: url("/static/images/common/overal.png");
  background-size: 100% 100%;
  background-repeat: "no-repeat";
  z-index: -1;
}

.changeSet {
  display: block;
  height: 100px;
  width: 100px;
  background: black;
  position: absolute;
  top: 0px;
  left: 0px;
  pointer-events: all;
}
</style>
